export default __webpack_public_path__ + "static/media/ICONOS INGLÉS  MI SEGURO SOMIT -19.67246603.png";